import { GeofenceLocation } from "@verity/proctoring-option/types";
import { CustomSettingData } from "../../settings-page";
import { GeofenceModal, ThemeWrapper } from "@verity/components";
import styles from "./index.module.css";
import { Typography } from "@mui/material";
import i18n from "../../../../i18n";
import { CoreButton } from "@verity/components/core";
import { useState } from "react";
import apiClient from "../../../../helpers/api-client";

export const SavedGeofenceInput = ({
	loadData,
	setting,
	onSettingChange,
}: {
	loadData: GeofenceLocation[];
	setting: CustomSettingData<GeofenceLocation[]>;
	onSettingChange: (value?: GeofenceLocation[] | undefined, options?: object) => void;
}) => {
	const [modalOpen, setModalOpen] = useState<boolean>(false);
	const [savedGeofences, setSavedGeofences] = useState<GeofenceLocation[] | undefined>(setting.value ?? loadData);

	return (
		<ThemeWrapper>
			<div className={styles.geofenceOuterContainer}>
				<div className={styles.geofenceInnerContainer}>
					<Typography>{i18n.t("portal.components.settings.savedGeofencesCourse.description")}</Typography>
					<CoreButton onClick={() => setModalOpen(true)} aria-haspopup="dialog">
						{i18n.t("portal.components.settings.savedGeofencesCourse.button")}
					</CoreButton>
				</div>
			</div>
			{modalOpen && (
				<GeofenceModal
					onClose={() => setModalOpen(false)}
					allowEdit={true}
					presetGeofences={savedGeofences}
					onSave={(_, geofences) => {
						setSavedGeofences(geofences);
						onSettingChange(geofences);
						setModalOpen(false);
					}}
				/>
			)}
		</ThemeWrapper>
	);
};

export const validateSavedGeofence = (obj: unknown): obj is GeofenceLocation[] => {
	return (
		Array.isArray(obj) &&
		obj.every((item) => {
			if (typeof item !== "object" || item === null) {
				return false;
			}

			const geoItem = item as { [key: string]: unknown };

			return (
				"longitude" in geoItem &&
				typeof geoItem.longitude === "number" &&
				"latitude" in geoItem &&
				typeof geoItem.latitude === "number" &&
				"radius" in geoItem &&
				typeof geoItem.radius === "number" &&
				"name" in geoItem &&
				typeof geoItem.name === "string" &&
				"isMetric" in geoItem &&
				typeof geoItem.isMetric === "boolean"
			);
		})
	);
};

export async function saveNewGeofenceLocations(verityCoruseId?: number, newGeofences?: GeofenceLocation[]) {
	try {
		if (verityCoruseId) {
			if (newGeofences) {
				await apiClient.course.updateCourseSettings(verityCoruseId, {
					geofenceLocations: newGeofences,
				});
			}
		} else {
			throw new Error("no verity course id");
		}
		return { ok: true };
	} catch (error) {
		console.error(error);
		return { ok: false, reason: "Failed to save geofence locations" };
	}
}

export default SavedGeofenceInput;
